const CURRENCY_SYMBOL = {
  ARS: '$',
  USD: 'US$',
  EUR: '€',
};

export function formatMoney(amount, currency = 'ARS', { showCode = false } = {}) {
  const c = String(currency || 'ARS').toUpperCase();
  const n = Number(amount);
  const value = Number.isFinite(n) ? n : 0;

  if (showCode || !['ARS', 'USD', 'EUR'].includes(c)) {
    return `${c} ${value.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  try {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: c,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  } catch {
    const sym = CURRENCY_SYMBOL[c] || c;
    return `${sym} ${value.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
}

export function formatMoneyPair(originalAmount, currency, arsAmount, tipoCambio) {
  const line1 = formatMoney(originalAmount, currency, { showCode: true });
  if (!currency || currency === 'ARS' || arsAmount == null) return line1;
  const tc = tipoCambio ? ` (TC ${Number(tipoCambio).toLocaleString('es-AR')})` : '';
  return `${line1} → ${formatMoney(arsAmount, 'ARS')}${tc}`;
}
